export const probesActionTypes = {
  ADD_TO_PROBES: 'ADD_TO_PROBES',
  ADD_TO_PROBES_FAILURE: 'ADD_TO_PROBES_FAILURE',
  REMOVE_FROM_PROBES: 'REMOVE_FROM_PROBES',
  FETCH_PROBES_REQUEST: 'FETCH_PROBES_REQUEST',
  FETCH_PROBES_SUCCESS: 'FETCH_PROBES_SUCCESS',
  FETCH_PROBES_ERROR: 'FETCH_PROBES_ERROR',
  BANNER_PROBES_SUCCESS: 'BANNER_PROBES_SUCCESS',
  SEARCH_PROBE_SUCCESS: 'SEARCH_PROBE_SUCCESS',
  SEARCH_PROBE_ERROR: 'SEARCH_PROBE_ERROR',
  SET_SORTING_ORDER: 'SET_SORTING_ORDER',
  SET_FILTER_ORDER: 'SET_FILTER_ORDER',
  FETCH_PROBES_MULTI_SUCCESS: 'FETCH_PROBES_MULTI_SUCCESS',
  FETCH_HASHTAG_PROBES_REQUEST: 'FETCH_HASHTAG_PROBES_REQUEST',
  FETCH_HASHTAG_PROBES_SUCCESS: 'FETCH_HASHTAG_PROBES_SUCCESS',
  FETCH_HASHTAG_PROBES_ERROR: 'FETCH_HASHTAG_PROBES_ERROR',
};
